<template>
    <section>
        <div class="attachment-wrapper" v-for="( voting, index ) in votings" :key="index">
            <img src="../../assets/icons/components/voting.svg" style="height: 17px;" />
            <span :class="voting.status != 3 ? 'votings-new' : 'votings-ended'"> {{ voting.name }} {{voting.isPublic == false ? '('+ $t('com.public-session-info.secret-voting') +')' : ''}} </span>
        </div>
    </section>
</template>

<script charset="utf-8">
export default {
    name: "VotingListPublicModal",
    data() {
        return {

        };
    },
    props: {
        votings: Object
    },
};
</script>

<style lang="scss" scoped>
    .attachment-wrapper {
        margin-right: 42px;
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 10px;

        &:nth-child(1)::after {
            width: 0px;
            height: 0px;
        }

        &:after {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: -21px;
            width: 1px;
            height: 16px;
            background: #dde0e7;
        }
    }

    .votings-ended {
        color: #4cad39;
        font-size: 14px;
        font-weight: bold;
        font-size: 14px;
        margin-left: 11px;
    }

    .votings-new {
        font-size: 14px;
        font-size: 14px;
        margin-left: 11px;
    }
</style>